import { combineReducers } from "redux";
import athleteSportListReducer from './athleteSportList'

export default combineReducers({
   primaryAthleteSportList: athleteSportListReducer
})